import CreateUpdateClientVatTypes from "../components/CreateUpdateClientVatTypes";
import RemoveButton from "../components/RemoveButton";
import { useTranslation } from "react-i18next";
import { Space } from "antd";

export default function useTableColumns(refetch: any) {
  const { t } = useTranslation();

  return [
    {
      title: t("Code"),
      dataIndex: "code",
      key: "code",
      sorter: true,
      filterType: {
        type: "SearchFilter",
        varName: "search",
      },
    },
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      filterType: {
        type: "SearchFilter",
        varName: "name_Icontains",
      },
    },
    {
      dataIndex: t("Action"),
      key: "action",
      title: "Action",
      align: "center",
      width: "100px",
      render: (_text: unknown, record: Record<string, any>) => {
        return (
          <>
            {record?.editable && (
              <Space size="small" direction="horizontal" className="centered">
                <CreateUpdateClientVatTypes id={record.id} refetch={refetch} />
                <RemoveButton id={record.id} refetch={refetch} />
              </Space>
            )}
          </>
        );
      },
    },
  ];
}
